<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">Upload File Template</span>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="category"
                    :items="fileCategories"
                    item-text="name"
                    item-value="value"
                    label="Category"
                    :rules="requiredRule"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="title"
                    label="Template Name"
                    color="blue"
                    :rules="requiredRule"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-menu
                    :close-on-content-click="true"
                    full-width
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="fileName"
                        readonly
                        label="Attach document"
                        prepend-icon="attach_file"
                        :rules="requiredRule"
                        v-on="on"
                        @click="$refs.fileInput.click()"
                      />
                    </template>
                    <input
                      ref="fileInput"
                      type="file"
                      accept="application/pdf"
                      style="display:none"
                      @input="onFileChange"
                    >
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="closeDialog()"
          >
            cancel
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="submit()"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import FileCategoriesEnum from '../../enum/financialProducts/FileCategories';

export default {
  name: 'UploadFile',
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      required: true,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      category: null,
      title: null,
      file: null,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  computed: {
    fileCategories() {
      return Object.keys(FileCategoriesEnum)
        .filter(category => category !== 'ZEICHNUNGSSCHEIN')
        .map(key => FileCategoriesEnum[key])
        .sort();
    },
    fileName() {
      return this.file ? this.file.name : null;
    },
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.submitAction({
          category: this.category,
          title: this.title,
          fileName: this.fileName,
          file: this.file,
          template: true,
        });
        this.closeDialog();
      }
    },
    closeDialog() {
      this.cancelAction();
      this.setToDefault();
    },
    setToDefault() {
      this.category = null;
      this.title = null;
      this.file = null;
      this.valid = true;
    },
    async onFileChange(e) {
      try {
        const [file] = e.target.files;
        this.file = file;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financialProducts/UploadFile.vue